import * as calculatorConfig from '@/config/base-config.json';
import { GST_DEFAULT, SSD_LIST } from '@/constants/common';
import { generateSliderSteps } from '@/utils/generateSliderSteps';

export const MAX_PROFILES = 4;

export const PRIVATE_SALES_PROCEEDS_LABEL = {
  SalesInformation: 'Sales Information',
  SellingPrice: 'Selling Price',
  OutstandingLoan: 'Outstanding Loan',
  OptionFee: 'Option Fee',
  OptionExerciseFee: 'Option Exercise Fee',
  CPFUsedForHousing: 'CPF Used For Housing',
  CPFAccruedInterest: 'CPF Accrued Interest',
  PotentialExpenses: 'Potential Expenses',
  SSDLongForm: "Seller's Stamp Duty",
  LegalFee: 'Legal Fee',
  BanksPenaltyIfAny: "Bank's Penalty, If Any",
  BanksPenalty: "Bank's Penalty",
  ServiceCommission: 'Service Commission',
  GST: 'GST',
  Others: 'Others',
  Negative: 'Negative',
  SalesProceedsBreakdown: 'Sales Proceeds Breakdown',
  CPFUsedPlusInterest: 'CPF Used + Interest',
  SalesProceeds: 'Sales Proceeds',
  OtherExpenses: 'Other Expenses',
  SalesProceedsTimeline: 'Sales Proceeds Timeline',
  OTPLongForm: 'Option to Purchase',
  OTP: 'OTP',
  ExercisePeriod: 'Exercise Period',
  CompletionPeriod: 'Completion Period',
  TemporaryExtensionOFStay: 'Temporary Extension Of Stay',
  Weeks: 'Weeks',
  Months: 'Months',
  PlusAddProfile: '+ Add Profile',
  AdditionalProfile: 'Additional Profile',
  ExerciseOfOTP: 'Exercise of OTP',
  SalesCompletion: 'Sales Completion',
  Balance: 'Balance',
  OptionExerciseFeeIncluded: 'Option Exercise Fee Included',
  AgentFee: 'Agent Fee',
  Amount: 'Amount',
  ActualHandover: 'Actual Handover',
  GenerateTimeline: 'Generate Timeline',
};
export const BREAKDOWN_COLORS = {
  OutstandingLoan: '#F25A73',
  CPFUsedPlusInterest: '#F692A3',
  PotentialExpenses: '#F8CB59',
  SalesProceeds: '#9475EB',
};
export const OPTION_FEE = {
  DEFAULT: calculatorConfig.option_fee_in_percent.default,
  RANGE: generateSliderSteps(0, calculatorConfig.option_fee_in_percent.max),
  MIN: calculatorConfig.option_fee_in_percent.min,
};
export const OPTION_EXERCISE_FEE = {
  DEFAULT: calculatorConfig.option_exercise_fee_in_percent.default,
  RANGE: generateSliderSteps(0, calculatorConfig.option_exercise_fee_in_percent.max),
  MIN: calculatorConfig.option_exercise_fee_in_percent.min,
};
export const LEGAL_FEE = {
  DEFAULT: calculatorConfig.legal_fee,
};
export const SSD = {
  DEFAULT: '0',
  LIST: SSD_LIST.map((value) => {
    return {
      value: value.toString(),
      label: `${value}%`,
    };
  }),
};
export const YES = 'yes';
export const NO = 'no';
export const BANK_PENALTY_IF_ANY = {
  LIST: [
    { value: YES, label: 'Yes' },
    { value: NO, label: 'No' },
  ],
};
export const BANK_PENALTY = {
  DEFAULT: calculatorConfig.bank_penalty_in_percent.default,
  MAX: calculatorConfig.bank_penalty_in_percent.max,
  STEP: 0.5,
  LABEL_INPUTS: generateSliderSteps(
    calculatorConfig.bank_penalty_in_percent.min,
    calculatorConfig.bank_penalty_in_percent.max,
    0.5,
  ),
};
export const EXERCISE_PERIOD = {
  DEFAULT: calculatorConfig.exercise_period_in_weeks.default,
  MIN: calculatorConfig.exercise_period_in_weeks.min,
  MAX: calculatorConfig.exercise_period_in_weeks.max,
  STEP: 1,
  LABEL_INPUTS: generateSliderSteps(
    calculatorConfig.exercise_period_in_weeks.min,
    calculatorConfig.exercise_period_in_weeks.max,
  ),
};
export const COMPLETION_PERIOD = {
  DEFAULT: calculatorConfig.completion_period_in_weeks.default,
  MIN: calculatorConfig.completion_period_in_weeks.min,
  MAX: calculatorConfig.completion_period_in_weeks.max,
  STEP: 1,
  LABEL_INPUTS: generateSliderSteps(
    calculatorConfig.completion_period_in_weeks.min,
    calculatorConfig.completion_period_in_weeks.max,
  ),
};
export const TEMPORARY_EXTENSION_OF_STAY = {
  DEFAULT: calculatorConfig.temporary_extension_stay_in_months.default,
  MIN: calculatorConfig.temporary_extension_stay_in_months.min,
  MAX: calculatorConfig.temporary_extension_stay_in_months.max,
  STEP: 0.5,
  LABEL_INPUTS: generateSliderSteps(
    calculatorConfig.temporary_extension_stay_in_months.min,
    calculatorConfig.temporary_extension_stay_in_months.max,
    0.5,
  ),
};
export const SERVICE_COMMISSION_PERCENT = calculatorConfig.service_commission_in_percent;
export const GST_PERCENT = GST_DEFAULT;
